// extracted by mini-css-extract-plugin
export default {"root":"CampaignInfoEdit_root__ij0tR","input":"CampaignInfoEdit_input__NuF0t"};